export class FormStandDto {
    standId: number;

    constructor() {
        this.standId = 0;
    }
}